import type { CaseTypeDto } from '@peritasai/types';

export class CaseTypeEntity {
  public readonly id: string;
  public readonly caseTypeId: string | null;
  public readonly displayName: string | null;
  public readonly description: string | null;
  public readonly specialty: string | null;
  public readonly procedureCode: string | null;

  constructor(dto: CaseTypeDto) {
    this.id = dto.id;
    this.caseTypeId = dto.caseTypeId ?? null;
    this.displayName = dto.displayName ?? null;
    this.description = dto.description ?? null;
    this.specialty = dto.specialty ?? null;
    this.procedureCode = dto.procedureCode ?? null;
  }
}
